import Vue from 'vue';
import Router from 'vue-router';
import { store } from '@/app/shared/stores/store';

import Home from '@/app/dashboard/dashboard/home.vue';
import Club from '@/app/dashboard/dashboard/club.vue';
import Contacts from '@/app/dashboard/dashboard/contacts.vue';
import Courses from '@/app/dashboard/dashboard/courses.vue';
import TeeSheet from '@/app/dashboard/dashboard/teesheet.vue';
import Events from '@/app/dashboard/dashboard/events.vue';
import Settings from '@/app/dashboard/dashboard/settings.vue';
import Help from '@/app/dashboard/dashboard/help.vue';
import Dashboard from './dashboard/dashboard.vue';
import { dashboardRoutes } from './dashboard';
import Login from './login/login.vue';

Vue.use(Router);

const appRoutes = [
  {
    path: '',
    component: Dashboard,
    children: [
      {
        path: '',
        component: Home,
        name: '',
      },
      {
        path: '/Club',
        component: Club,
        name: 'Club',
      },
      {
        path: '/Contacts',
        component: Contacts,
        name: 'Contacts',
      },
      {
        path: '/Courses',
        component: Courses,
        name: 'Courses',
      },
      {
        path: '/TeeSheet',
        component: TeeSheet,
        name: 'TeeSheet',
      },
      {
        path: '/Events',
        component: Events,
        name: 'Events',
      },
      {
        path: '/Settings',
        component: Settings,
        name: 'Settings',
      },
      {
        path: '/Help',
        component: Help,
        name: 'Help',
      },
    ],
  },
  {
    path: '/',
    component: Dashboard,
    children: [
      {
        path: '',
        component: Home,
      },
    ],
  },
  {
    path: '/Login',
    component: Login,
  },
  {
    path: '*',
    component: Dashboard,
    children: [
      {
        path: '*',
        component: Home,
        name: '',
      },
    ],
  },
];

const routes = [...appRoutes, ...dashboardRoutes];

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (store.state.user.isAuthenticated) {
    next();
  } else if (to.matched.some(record => record.meta.noAuth === undefined)) {
    if (to.path !== '/Login') {
      router.push('/Login');
    }
    next();
  } else {
    // No auth needed
    next();
  }
});


export default router;
